import { useEffect, useState } from "react";
import { getUserService } from "../Services/auth";
import { setUserInfo } from "../Redux/Admin/AdminSlice";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

export const useIsLogin = ()=>{
  const { pathname } = useLocation();
    const [isLogin, setIsLogin] = useState(false);
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch()
    
    const handleCheckLogin = async ()=>{
      try {
        const res = await getUserService()
        const userData = res.data.value;
        dispatch(setUserInfo(userData));
        setIsLogin(true);
        setLoading(false);
      } catch (error) {
        setIsLogin(false);
        setLoading(false);
      }
    }

    useEffect(() => {
    handleCheckLogin()
    }, [pathname]);

    return [loading, isLogin]
}